import { render, staticRenderFns } from "./AlterarProduto.vue?vue&type=template&id=4d6494fa"
import script from "./AlterarProduto.vue?vue&type=script&lang=ts"
export * from "./AlterarProduto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports